import {
  styled
} from '@mui/material';

export const getOrderNumbers = (selected) => {
    const uniqueOrderIds = [...new Set(selected.map((item) => item.orderid))];
    return uniqueOrderIds.join(',');
}

export const getMobileMask = (e) => {
    const { value, name } = e.target;

    const result = value
      .replace(/[^0-9.]/g, "")
      .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
      .replace(/(-{1,2})$/g, "");
    
    return result;
};

export const getBizLicenseMask = (e) => {
  const { value, name } = e.target;

  const result = value
    .replace(/[^0-9.]/g, "")
    .replace(/^(\d{0,3})(\d{0,2})(\d{0,5})$/g, "$1-$2-$3")
    .replace(/(-{1,2})$/g, "");
  
  return result;
};

export const ImgStyled = styled('img')(({ theme }) => ({
  width: 120,
  height: 120,
  marginRight: theme.spacing(5),
  borderRadius: theme.shape.borderRadius
}))